import ru from '../i18n/ru.json';

export const locales = {
  ru,
};
